import { Col, Row } from 'antd';

import emojiSad from '~/assets/icons/emoji.png';
import dbsLogo from '~/assets/logos/dbs-logo.png';
import Image from '~/components/Image/Image';
import { Paragraph, Text } from '~/components/Typo/Typo';
import { FontWeight } from '~/theme/constants';

import './Login.scss';

const Login = () => (
  <div className="login">
    <div className="login-container">
      <Row justify="center" align="middle" gutter={[32, 32]}>
        <Col lg={10} md={12} sm={24} xs={24} className="login-first-part">
          <Image className="logo-part" image={dbsLogo} />
          <div className="text-content">
            <Paragraph className="maintenance-title">
              <Text className="title-text" weight={FontWeight.BOLD}>
                Plateforme temporairement hors service
              </Text>
            </Paragraph>
            <Paragraph className="maintenance-message">
              <Text className="message-text" weight={FontWeight.NORMAL}>
                Veuillez réessayer dans quelques minutes
              </Text>
            </Paragraph>
          </div>
        </Col>
        <Col lg={8} md={10} sm={0} xs={0} className="login-second-part">
          <Image className="icon" image={emojiSad} />
        </Col>
      </Row>
    </div>
  </div>
);

export default Login;
